<template>
  <div class="governance-view">
    <h1 class="text-h4 mb-4">{{ t('gov.title') }}</h1>

    <v-row class="mb-4">
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>{{ t('gov.totalProposals') }}</v-card-title>
          <v-card-text class="text-h3">{{ stats.total_proposals || 0 }}</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>{{ t('gov.active') }}</v-card-title>
          <v-card-text class="text-h3 text-green">{{ stats.active_proposals || 0 }}</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Executadas</v-card-title>
          <v-card-text class="text-h3 text-blue">{{ stats.executed_proposals || 0 }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="mb-4">
      <v-card-title>{{ t('gov.proposals') }}</v-card-title>
      <v-card-text>
        <v-table v-if="proposals.length > 0">
          <thead>
            <tr>
              <th>ID</th>
              <th>{{ t('gov.proposalTitle') }}</th>
              <th>{{ t('gov.type') }}</th>
              <th>{{ t('tx.status') }}</th>
              <th>{{ t('gov.votes') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in proposals" :key="p.id">
              <td><code>{{ p.id.slice(0, 12) }}...</code></td>
              <td>{{ p.title }}</td>
              <td><v-chip size="small">{{ p.type }}</v-chip></td>
              <td>
                <v-chip :color="p.status === 'Active' ? 'green' : 'grey'" size="small">
                  {{ p.status }}
                </v-chip>
              </td>
              <td>{{ p.votes_count }}</td>
            </tr>
          </tbody>
        </v-table>
        <p v-else class="text-grey">{{ t('gov.noProposals') }}</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ExplorerAPI } from '@/services/api'

const stats = ref({})
const proposals = ref([])

onMounted(async () => {
  try {
    stats.value = await ExplorerAPI.governanca.estatisticas()
    const data = await ExplorerAPI.governanca.listarPropostas()
    proposals.value = data.proposals || []
  } catch (e) {
    console.error('Erro ao carregar governança:', e)
  }
})
</script>
